import classes from './RatingPage.module.scss';
import { FullPageContainer } from '../../common/FullPageContainer/FullPageContainer';
import { RatingHighlights } from './components/RatingHighlights/RatingHighlights';
import { ReservationsHighlights } from './components/ReservationsHighlights/ReservationsHighlights';

import { Typography } from '@/shared/ui/typography';
import { isMobileModeSelector } from '../../../redux/selectors/appStatusSelector';
import { useDispatch, useSelector } from 'react-redux';
import { clsx } from 'clsx';
import { PeriodDropdown } from '../../common/PeriodDropdown/PeriodDropdown';
import { ratingPeriodSelector } from '@/redux/selectors/ratingSelector';
import { periodList } from '@/utils/constants/periodLists';
import { SET_RATING_PERIOD } from '@/redux/actions';

export const RatingPage = () => {
  const isMobileView = useSelector(isMobileModeSelector);
  const period = useSelector(ratingPeriodSelector);
  const dispatch = useDispatch();

  const setPeriod = (period: string) => {
    dispatch({
      type: SET_RATING_PERIOD,
      payload: { period },
    });
  };

  const newPeroidList = periodList
  .filter((period) => period.id.toLowerCase() !== 'next 30 days')
  .map((period) =>
    period.id.toLowerCase() === 'last 12 months'
      ? { ...period, label: 'Year to date' }
      : period
  );
  
  return (
    <FullPageContainer className={classes.ratingContainer}>
      <>
        <div className={classes.header}>
          <Typography
            variant={isMobileView ? 'display-xs' : 'display-md'}
            weight='semibold'
            className={clsx(classes.gray900, classes.title)}
          >
            Rating
          </Typography>
          <PeriodDropdown
            className={classes.outlinedDropdown}
            period={period}
            periodList={newPeroidList}
            setPeriod={setPeriod}
          />
        </div>
        <RatingHighlights period={period} />
        <ReservationsHighlights period={period} />
      </>
    </FullPageContainer>
  );
};
